<nav>
  <div class="navbar h-20 bg-base-100 drop-shadow-lg fixed z-10 p-0">
    @if(showBack()){
      <div class="flex-none lg:pl-10 px-5 h-full">
        <button (click)="goBack()"
          id="navbar-logo"
          class="flex h-full items-center font-bold lg:text-4xl text-3xl cursor-pointer">
          <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M44 24.0001C44 25.1047 43.1046 26.0001 42 26.0001H10.34L19.52 36.7001C20.238 37.5396 20.1395 38.8022 19.3 39.5201C18.4605 40.2381 17.198 40.1396 16.48 39.3001L4.48 25.3001C4.40835 25.2005 4.34798 25.0931 4.3 24.9801C4.2398 24.9049 4.18627 24.8246 4.14 24.7401C4.05334 24.5027 4.00605 24.2528 4 24.0001C4.00605 23.7475 4.05334 23.4975 4.14 23.2601C4.18627 23.1756 4.2398 23.0953 4.3 23.0201C4.34798 22.9071 4.40835 22.7998 4.48 22.7001L16.48 8.70014C17.198 7.86066 18.4605 7.76217 19.3 8.48014C20.1395 9.19811 20.238 10.4607 19.52 11.3001L10.34 22.0001H42C43.1046 22.0001 44 22.8956 44 24.0001Z"
              fill="#231F20" />
          </svg>
        </button>
      </div>
      <div class="flex-1">
        <a class="flex items-center font-bold lg:text-3xl text-2xl">
          <img class="h-10 w-10" src="/myrank_logo_no_text.png" alt="">
          <div class="ml-1">MyRank</div>
        </a>
      </div>
    } @else {
      <div class="flex-1">
        <a class="flex items-center font-bold lg:text-3xl text-2xl lg:px-10 px-5">
          <img src="myrank_logo_no_text.png" alt="MyRank Logo" class="h-10 object-center object-fill mr-2">
          MyRank
        </a>
      </div>
    }

    <div class="navbar-end">
      <a
        id="navbar-user"
        class="items-center lg:font-bold font-semibold text-xl lg:px-10 px-5 truncate hidden sm:inline"
      >
        {{ email() }}
      </a>
    </div>
  </div>
</nav>
